import React from "react";
import { useNavigate } from "react-router-dom";
import { Button, Box, Typography, CardContent } from "@mui/material";
import Card from "@mui/material/Card";
import Arrow from "../../../Assets/Svg/offersarrow.svg";
import { Styles } from "./styles";
import { showIconByServiceId } from "../../../helpers/showIconByServiceId";

const GroupCard = ({ data }) => {
  const navigate = useNavigate();
    const handleNavigation = (id) => {
        window.open(`${window.location.origin}/SmmDomainDetails/${id}`, '_blank', 'noopener,noreferrer');
        // navigate(`/AdsPanelsDetails/${uuid}`);
    };
  return (
    <Styles>
        <Box
            className="item-carosel"
            style={{padding : '0',width:'100%'}}
            key={data.id}
            onClick={() => handleNavigation(data.id)}
        >

                <div className="final-logo-container" style={{alignContent:'center',minHeight:'100px',margin:'0 20px'}}>
                    <Typography
                        sx={{
                            fontSize: `17px`,
                            color: '#ffffff',
                        }}
                        className="final-logo"
                    >
                        {data.domain}
                    </Typography>
                    <Typography
                        sx={{
                            fontSize: `14px`,
                            color: '#ffffff',
                        }}
                        className="final-logo"
                    >
                        {data.price} $
                    </Typography>
                </div>

        </Box>
    </Styles>
  );
};

export default GroupCard;
